const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getConsolidationSetupData(metaData) {

      const url = getUrl('user-portfolio-relations');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = { 
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));


    },
     setConsolidationSetupData(branchCode,pfId,relId,metaData) {
      const url = getUrl('save-user-rel-portfolio-selection');
      const parsedMetaData = parseRequestMetaData(metaData); //Check wd others
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode,
        pfId,
        relId
      };
      const reqOpts = { 
        headers:merge(headers, parsedMetaData.headers), 
        method: 'POST'
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },

  };
}

module.exports = apiFactory;
